import { CommonHttpOption } from "../../base/common-http-option";
import { CoreService } from "../../base/core";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";

@Injectable({
  providedIn: "root"
})
export class CityService {
  constructor(private core: CoreService) {}

  GetList(id: number, page: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.cities.list + id,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
}
